<h1 mat-dialog-title>{{headline}}</h1>
<mat-dialog-content>
  {{content}}
</mat-dialog-content>
<mat-dialog-actions (keyup.enter)="confirmDialog()" class="mat-dialog-buttons">
  <button (click)="cancelDialog()" mat-raised-button>Abbrechen</button>
  <button (click)="confirmDialog()" color="warn" mat-raised-button>{{action}}</button>
</mat-dialog-actions>
